"use strict";

var _defineProperty = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlEntities = exports.getNowDate = exports.diffDay = exports.getSessionStorage = exports.setSessionStorage = exports.getLocalStorage = exports.setLogcalStorage = exports.getAuthInfo = exports.inflowLog = exports.vodInflowLog = exports.liveInflowLog = exports.setClickLogapi = exports.isDarkMode = exports.handleFetchErrors = void 0;

var js_cookie_1 = __importDefault(require("js-cookie"));

var domains_1 = require("@afreecatv/domains");

var query_string_1 = __importDefault(require("query-string"));

var config_1 = require("./constants/config");

var handleFetchErrors = function handleFetchErrors(response) {
  if (!response.ok) {
    return response.json().then(function (json) {
      return Promise.reject(json);
    });
  }

  return response;
};

exports.handleFetchErrors = handleFetchErrors;
/**
 * 다크모드인지 체크
 * @returns
 */

var isDarkMode = function isDarkMode() {
  return document.documentElement.getAttribute("dark") === "true" || document.body.className.indexOf("thema_dark") > -1;
};

exports.isDarkMode = isDarkMode;
/**
 * CLICK로그
 */

var setClickLogapi = function setClickLogapi(code_type, sendData) {
  var data = Object.assign({
    sztype: "CLICK",
    code_type: code_type,
    send_data: query_string_1.default.stringify(sendData),
    sys_type: "web"
  }); //로딩

  return fetch("".concat(config_1.LOG_API_DOMAIN, "/set_log_api.php"), {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify(data),
    credentials: "include"
  });
};

exports.setClickLogapi = setClickLogapi;

var liveInflowLog = function liveInflowLog(bj_id, broadNo, paths) {
  (0, exports.inflowLog)("LIVE", bj_id, broadNo, paths);
};

exports.liveInflowLog = liveInflowLog;

var vodInflowLog = function vodInflowLog(bj_id, titleNo, paths) {
  (0, exports.inflowLog)("VOD", bj_id, titleNo, paths);
};

exports.vodInflowLog = vodInflowLog;
/**
 * 진입로그
 * @param {string} code_type 타입
 * @param {string} bj_id
 * @param {number} contentNo 콘텐츠번호
 * @param {array} paths
 */

var inflowLog = function inflowLog(code_type, bj_id, contentNo) {
  var paths = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var cookieName = "";
  var inflowLogData = {};
  var tmToday = new Date();

  var _au = js_cookie_1.default.get("_au");

  var path_key = _au + "_" + (!!contentNo && Number(contentNo) !== 0 ? contentNo : bj_id) + "_" + tmToday.getTime();
  var inflowPath = paths.reduce(function (accumulator, value, index) {
    accumulator["path".concat(index + 1)] = value;
    return accumulator;
  }, []);
  var sysType = "web";
  var os = "win";

  switch (code_type) {
    case "LIVE":
      cookieName = "LIN";
      inflowLogData = _objectSpread({
        bj_id: bj_id,
        broad_no: contentNo,
        referer: window.location.href
      }, inflowPath, {
        os: os
      });
      break;

    case "VOD":
      cookieName = "VIN";
      inflowLogData = _objectSpread({
        bj_id: bj_id,
        title_no: contentNo,
        referer: window.location.href
      }, inflowPath, {
        os: os
      });
      break;

    default:
      break;
  }
  /**
   * 로그호출
   */


  fetch("".concat(config_1.LOG_API_DOMAIN, "/set_log_api.php"), {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      sztype: "INFLOW_PATH",
      code_type: code_type,
      path_key: path_key,
      send_data: query_string_1.default.stringify(inflowLogData),
      sys_type: sysType
    }),
    credentials: "include"
  }).then(function () {});
  /**
   * 쿠키셋팅
   */

  tmToday.setTime(tmToday.getTime() + 10 * 1000); //10초 후 만료

  var cookieValue = query_string_1.default.stringify(_objectSpread({
    path_key: path_key
  }, inflowPath));
  js_cookie_1.default.set(cookieName, cookieValue, {
    path: "/",
    expires: tmToday,
    domain: config_1.DOMAIN
  });
};

exports.inflowLog = inflowLog;
/**
 * 로그인 정보 가져오기
 */

var getAuthInfo = function getAuthInfo() {
  var auth = {
    user_id: "",
    user_nick: ""
  };
  var pdBoxUser = js_cookie_1.default.get(domains_1.cookie.USER_COOKIE_NAME);

  if (!pdBoxUser) {
    return auth;
  }

  try {
    var aPdboxUser = decodeURIComponent(pdBoxUser).split('&');
    var userInfo = aPdboxUser.map(function (data) {
      return data.split("=");
    });
    auth.user_id = userInfo[0][1];
    auth.user_nick = userInfo[6][1];
    return auth;
  } catch (e) {
    return auth;
  }
};

exports.getAuthInfo = getAuthInfo;
/**
 * 로컬캐시 적용
 * @param {string} key storage key
 * @param {Array} data key에대한 value
 */

var setLogcalStorage = function setLogcalStorage(key) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.localStorage.setItem(key, JSON.stringify(data));
};

exports.setLogcalStorage = setLogcalStorage;
/**
 * 로컬캐시 가져오기
 */

var getLocalStorage = function getLocalStorage(key) {
  var localStorage = window.localStorage.getItem(key);

  if (!localStorage) {
    return false;
  }

  var localStorageData = JSON.parse(localStorage);
  return localStorageData;
};

exports.getLocalStorage = getLocalStorage;

var setSessionStorage = function setSessionStorage(key) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.sessionStorage.setItem(key, JSON.stringify(data));
};

exports.setSessionStorage = setSessionStorage;

var getSessionStorage = function getSessionStorage(key) {
  var sessionStorage = window.sessionStorage.getItem(key);

  if (!sessionStorage) {
    return false;
  }

  var sessionStorageData = JSON.parse(sessionStorage);
  return sessionStorageData;
};

exports.getSessionStorage = getSessionStorage;

var diffDay = function diffDay(regDate, updateDate) {
  var diffDay = new Date(regDate);
  var updateDay = new Date(updateDate === "" ? '' : updateDate);
  var diffTime = (updateDay.getTime() - diffDay.getTime()) / 1000 / 60;
  console.log(updateDay.getTime(), diffDay.getTime());
  return updateDay.getTime() === diffDay.getTime();
};

exports.diffDay = diffDay;

var getNowDate = function getNowDate() {
  var szDate = new Date();
  var szYear = szDate.getFullYear();
  var szMonth = (szDate.getMonth() + 1 < 10 ? "0" : "") + (szDate.getMonth() + 1);
  var szDay = (szDate.getDate() < 10 ? "0" : "") + szDate.getDate();
  var szHours = (szDate.getHours() < 10 ? "0" : "") + szDate.getHours();
  var szMinutes = (szDate.getMinutes() < 10 ? "0" : "") + szDate.getMinutes();
  var szNowTm = String(szYear) + "-" + String(szMonth) + "-" + String(szDay) + " " + String(szHours) + ":" + String(szMinutes);
  return szNowTm;
};

exports.getNowDate = getNowDate;
/**
 * head text 내용중 <, > 의 내용에 entity 처리
 * @param {string} szHtml 알림에서 headText
 * @returns {string}
 */

var htmlEntities = function htmlEntities(szHtml) {
  if (!szHtml) {
    return "";
  }

  szHtml = szHtml.replace(/</g, "&lt;");
  szHtml = szHtml.replace(/>/g, "&gt;");
  return szHtml;
};

exports.htmlEntities = htmlEntities;